import { useRef, useState } from "react"
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { getYouTubeEmbedId } from "../utils/videoUtils";
import { useNavigate } from 'react-router-dom';
import { saveBookmarksInNotes } from "../../storage/LocalStorage";
import { StyledGrid } from "../style/StyledComponents";

const urlPrexif = "https://www.youtube.com/watch?v="

const VideoForm = ({
                    url,
                    handleSubmit, 
                    setUrl,
                  }) => {
    
    const [error, setError] = useState(false);
    const hiddenFileInput = useRef(null);
    const navigate = useNavigate();

    const handleImportClick = () => {
      hiddenFileInput.current.click();
    };

    const handleImport = (event) => {
      const fileUploaded = event.target.files[0];
      if (!fileUploaded){
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const video_form = JSON.parse(text);
        const embedId = video_form.embedId;
        const videoDetails = {
          title: video_form.title,
          updateTime: Date.now(),
          bookmark: video_form.bookmarks,
          section: video_form.section ? video_form.section : 0,
        };
        saveBookmarksInNotes(embedId, videoDetails);
        navigate("/video" + "/" + embedId);
      };
      reader.readAsText(fileUploaded);
    };
    
    const handleChange = (e) => {
      const val = e.target.value;
      const embedId = getYouTubeEmbedId(val);
      if (embedId == null) {
        setError(true);
      } else {
        setError(false);
      }
      setUrl(val);
    };

    return <>
        <StyledGrid container columns={20} spacing={2} sx={{width: "100%", padding: "1rem"}}>
          <Grid item xs={18} sm={10} md={13}>
            <TextField
              error={error}
              id="url"
              label="Youtube URL"
              variant="outlined"
              value={url}
              size="small"
              fullWidth={true}
              onChange={(e) => {handleChange(e)}}
            />
          </Grid>
          <Grid item xs={16} sm={10} md={7}>
            <Grid container columns={18} spacing={2}>
              <Grid item>
                <Tooltip title="Submit the url to load the video!" size="md" arrow>
                  <Button 
                  variant="contained" 
                  onClick={(e) => handleSubmit(e)}
                  disabled={error}
                  style={{ textTransform: 'capitalize' }}
                  >Submit</Button>
                </Tooltip>
              </Grid>
              <Grid item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant="h6" component="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                OR
              </Typography>
              </Grid>
              <Grid item>
              <Tooltip title="Load clipThoughts' json file with previously saved notes." size="md" arrow>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleImportClick}
                  style={{ textTransform: 'capitalize' }}
                  sx={{ height: '38px'}}
                  >
                  Load
                </Button>
                </Tooltip>
                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleImport}
                  style={{ display: 'none' }} // Hide the file input
                />
              </Grid>
            </Grid> 
          </Grid>
        </StyledGrid>  
    </>;
}

export default VideoForm;